const loadColorPickerColorsFromLocalStorage = (chartType) => {
  // retorna o array de cores memorizados em local storage
  const colors = JSON.parse(localStorage.getItem(`@analyze/${chartType}/color-picker-memorized-colors`));
  // se não existir este item no localStorage, ele retorna null
  return colors;
};
export default loadColorPickerColorsFromLocalStorage;
